import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { GameTable } from './game-table'
import { UserGame } from '@/lib/types.ts'

interface GamesTabProps {
  title: string
  description: string
  games?: UserGame[]
}

export function GamesTab({ title, description, games }: GamesTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <GameTable games={games} />
      </CardContent>
    </Card>
  )
}
